/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';

/**
 * A floating textarea. With output of an error description if invalid.
 * Spellcheck is enabled.
 *
 * @param {*} value value of the field
 * @param {*} handleChange On change function of the field,
 * default pass formik handleChange
 * @param {*} touched Boolean if the field was touched
 * @param {*} errorDescription Error description of the field, when invalid
 * @param {*} type Type of the input field, default 'text'
 * @param {*} fieldName Name of the field
 * @param {*} placeholder Placeholder of the field
 * @param {*} props Additional information like style or classname, for the label
 * @param {*} areaStyleProps Additional styles, for the textarea
 *
 * @return {*}
 */
const Textarea = ({
  value,
  handleChange,
  touched,
  errorDescription,
  type = 'text',
  fieldName,
  placeholder,
  props,
  areaStyleProps,
}) => {
  return (
    <FloatingLabel
      controlId="floatingInput"
      label={placeholder}
      {...props}
    >
      <Form.Control
        type={type}
        name={fieldName}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        isValid={touched && !errorDescription}
        isInvalid={!!errorDescription}
        as="textarea"
        spellCheck
        style={areaStyleProps}
      />
      <Form.Control.Feedback type="invalid">
        {errorDescription}
      </Form.Control.Feedback>
    </FloatingLabel>
  );
};

export default Textarea;
